import React from "react";
import { useTranslation } from "react-i18next";

function MaterialEvents(props) {
  const { push, length, setOpenLogin, lengthQuiz, pushQuiz } = props;
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  return (
    <section id="material-webs">
      <h1>{t("material-set")}</h1>
      <div className="parents-mate">
        {length > 0 && (
          <div
            onClick={() => {
              if (token && token !== null) {
                push();
                return;
              }
              setOpenLogin(true);
            }}
            className="contents"
            style={{ width: lengthQuiz === 0 && "100%" }}
          >
            <div className="dv">
              <img src="/assets/images/e_folders.svg" alt="e_folders" />
              <div>
                <h4>{t("materials")}</h4>
                <p>
                  {length} {t("materials")}
                </p>
              </div>
            </div>
          </div>
        )}
        {lengthQuiz > 0 && (
          <div
            className="contents"
            onClick={() => {
              if (token && token !== null) {
                pushQuiz();
                return;
              }
              setOpenLogin(true);
            }}
            style={{ width: (length === 0 || !length) && "100%" }}
          >
            <div className="dv">
              <img src="/assets/images/e_kuis.svg" alt="e_folders" />
              <div>
                <h4>{t("quiz")}</h4>
                <p>
                  {lengthQuiz} {t("quiz")}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default MaterialEvents;
